<template>
  <div class="azyzhfls_fluid w_100">
    <div class="azyzhfls text_center">
      <div class="between">
        <sec-title Text="按专业找合肥律师" :showmore='false' />
		<div class="tag between">
		  <div class="tag_list flex_start">
		    <div v-for="(item,index) in taglist" :key="index"
		    :class="{atg_activ:index==tagactive}"
		    @click="tagcl(index)"
		    >{{item.name}}</div>
		  </div>
		  <div class="mo">更多</div>
		</div>
      </div>
     

      <div class="cont between wrap">
        <qestlaywin  
        v-for="(item,index) in 6" 
        :key="index"
        class="item" 
        :class="{mb60:index<3}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import qestlaywin from "../components/qestlaywin2";
export default {
  components: {
    secTitle,
    qestlaywin
  },
  data: () => ({
      tagactive:0,
      taglist:[
          {name:'交通事故'},
          {name:'房产纠纷'},
          {name:'刑事辩护'},
          {name:'人身损害'},
          {name:'婚姻家庭'},
          {name:'劳动纠纷'},
          {name:'债务追讨'},
      ]
  }),
  methods: {
      tagcl(index){
          this.tagactive = index
      }
  },
};
</script>

<style lang="scss" scope>
.azyzhfls_fluid {
  background-color: #f8f8f8;
  .azyzhfls {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .tag {
      .tag_list {
        div {
          width: 100px;
          color: #c1c1c1;
          height: 30px;
          line-height: 30px;
        }
        .atg_activ {
          color: #fff;
          background: #0465ea;
        }
      }
      .mo {
        font-size: 14px;
        color: #666666;
      }
    }
    .cont{
        margin-top: 30px;
        margin-bottom: 40px;
        .item{
          width: 358px;
          height: 360px;
        }
        .mb60{
          margin-bottom: 60px;
        }
    }
  }
}
</style>